// extracted by mini-css-extract-plugin
module.exports = {"list":"c1YQ3","anchor":"_1TiZK","darkblue":"UFY27","darkgray":"R4IJY","gray":"_1h6SD","white":"_1z0fH","blackBold":"_1p14_"};